<template>
  <div id="app">
    <NavBar v-if="showNavAndFooter" />
    <main>
      <RouterView />
    </main>
    <Footer v-if="showNavAndFooter" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'

const route = useRoute()

const showNavAndFooter = computed(() => {
  return route.name !== 'Gokul'
})
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}</style> 